<template>
  <div class="introduce article" v-wechat-title="this.title">
    <div class="article-c" v-html="str">
      <img class="bigimg" :src="item" v-for="(item,index) in list" :key="item" @click="bigimg(item,index)">
    </div>
    <div class="article-btn">
      <van-button type="info" block round @click="goback" color="#0AA8AF">返回</van-button>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";
  import {
    ImagePreview
  } from 'vant'
  var jweixin = require('jweixin-module')
  Vue.use(ImagePreview)
  import {
    pageInfo
  } from '@/api/api'
  export default {
    data() {
      return {
        title: '',
        str: '',
        id: '',
        list: []
      }
    },
    mounted() {
      this.id = this.$route.query.id
      this.gettext()
    },
    methods: {
      bigimg(image, index) {
        ImagePreview({
          images: this.list,
          showIndex: true,
          loop: false,
          startPosition: index,
        })
      },
      async gettext() {
        await pageInfo({
          params: {
            "PageSearch[id]": this.id,
          }
        }).then((res) => {
          let str = ''
          str = res.data.items[0].content
          // var imgReg = /<img.*?(?:>|\/>)/gi;
          // var srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
          // var arr = str.match(imgReg);
          // console.log('所有已成功匹配图片的数组：' + arr);
          // for (var i = 0; i < arr.length; i++) {
          //   var src = arr[i].match(srcReg);
          //   //获取图片地址
          //   if (src[1]) {
          //     this.list.push(src[1])
          //     console.log('已匹配的图片地址' + (i + 1) + '：' + src[1]);
          //   }
          // }
          this.str = str.replace(/\<img/gi, '<img class="bigimg"');
          this.title = res.data.items[0].title
        })
      },
      goback() {
        this.$wechat.closeWindow()
      }
    }

  }
</script>

<style lang="scss" scoped>
  .introduce {
    height: 100%;
    width: 100%;
    padding-bottom: 70px;
    box-sizing: border-box;
    //     .text{
    //       padding: 10px; font-size: 14px;
    //     }
    //   .btn{
    //     position: fixed;
    //     bottom: 0;
    //     left: 0;
    //     background: #F7F8FF ;
    //     z-index: 99;
    //     padding-bottom: 20px;
    //     box-sizing: border-box;
    //  }
  }
</style>